import { every, get, isEmpty } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { REDUCER } from 'constants/entity-names';
import { getStore } from 'store';

// get store
const store = getStore();

/**
 * @type {function}
 * @desc Resolvers are pure functions used for resolving templates (React components) or to transform some data.
 * A resolver function takes an `id` and an optional `payload` and returns a `result`.
 * Based on `switch` cases inside this function, correct `result` should be returned.
 * @param {object} payload
 * @example
 * import { shouldTriggerMessageBus } from 'resolvers/shouldTriggerMessageBus';
 */
export const shouldTriggerMessageBus = ( { status, context: messageContext, props = {} } ) => {
    if ( status !== SERVICE_RESPONSE_STATUS.SUCCESS ) {
        return false;
    }

    if ( isEmpty( messageContext ) ) {
        return true;
    }

    const currentContext = {
        callId: get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null ),
        callType: get( store.getState()[ REDUCER.CALL_STATE ], 'callType', null ),
        callerType: get( store.getState()[ REDUCER.CALL_STATE ], 'callerType', null ),
        memberId: get( get( props.location, 'state', {} ), 'memberId', null )
    };

    return every( messageContext, ( value, item ) => currentContext[ item ] === value );
};
